import type {CSSProperties} from 'react';

export type ModalPhase = 'hidden' | 'preEnter' | 'enter' | 'idle' | 'leave';

export type DialogPanelMode = 'center' | 'bottom' | 'fullscreen';

export const MODAL_ANIMATION_MS = 300;

export const FOCUSABLE_SELECTOR =
  'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

export function getFocusableElements(container: HTMLElement): HTMLElement[] {
  return Array.from(container.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR)).filter(
    (element) => !element.hasAttribute('disabled') && element.tabIndex !== -1
  );
}

export function splitModalContentStyle(contentStyle: CSSProperties = {}) {
  const panelStyle: CSSProperties = {};
  const bodyStyle: CSSProperties = {...contentStyle};

  if (contentStyle.maxHeight != null) {
    panelStyle.maxHeight = contentStyle.maxHeight;
    delete bodyStyle.maxHeight;
  }
  if (contentStyle.height != null) {
    panelStyle.height = contentStyle.height;
    delete bodyStyle.height;
  }
  if (contentStyle.minHeight != null) {
    panelStyle.minHeight = contentStyle.minHeight;
    delete bodyStyle.minHeight;
  }

  delete bodyStyle.overflow;
  delete bodyStyle.overflowX;
  delete bodyStyle.overflowY;

  return {panelStyle, bodyStyle};
}
